import React, {Component} from 'react';
import {connect} from "react-redux";
import {selectOneProduct} from "../../actionCreators";

class ShopProducts extends Component {

  showPopupCart = (e) => {
    const {selectOneProduct} = this.props;
    let idProduct = e.currentTarget.dataset.id;
    selectOneProduct(idProduct);
  };

  renderProductsList = () => {
    const {renderProductsList, categories, loadedCat} = this.props;
    if (!loadedCat) return <div className="loading-b">loading...</div>;
    if (!categories || !categories.length) { return <div className="loading-b">No products</div>; }
    const productsElements = renderProductsList.map(productItem => (
      <li key={productItem.id} data-id={productItem.id} className="shop-choosen__item" onClick={this.showPopupCart}>
        <button className="shop-choosen__button" type="button">
          <div className="shop-choosen__img">
            <img src={productItem.icon} alt="" />
          </div>
          <div className="shop-choosen__title">{productItem.name}</div>
        </button>
      </li>
    ));
    return (
      <ul className="shop-choosen__list">
        {productsElements}
      </ul>
    )
  };

  render() {
    const {renderProductsList} = this;
    return (
      <section className="shop-choosen">
        <div className="container">
          <div className="shop-choosen__wrap">
            { renderProductsList() }
          </div>
        </div>
      </section>
    );
  }
}

export default connect((state) => {
  return {
    loadingCat: state.categories.loading,
    loadedCat: state.categories.loaded,
    categories: state.categories.categoriesList,
    isRenderingProducts: state.categories.isRenderingProducts,
    renderProductsList: state.categories.renderProductsList,
  }
}, {selectOneProduct})(ShopProducts);


// WEBPACK FOOTER //
// ./src/components/Shop/ShopProducts.js